// removed by extract-text-webpack-plugin
module.exports = {"episodeContent":"src-templates----episode-module---episodeContent---1wZaW","speakers":"src-templates----episode-module---speakers---17XRM","shareButtons":"src-templates----episode-module---shareButtons---1zS4W"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/episode.module.scss
// module id = 983
// module chunks = 199672004568253